import { darkSkyBlue, red } from "@govlaunch/palette";

import PropTypes from "prop-types";
import React from "react";

export default function Menu({ validationState, children, css, ...props }) {
  return (
    <div
      css={{
        position: "relative",
      }}
    >
      <div
        css={{
          position: "absolute",
          overflowY: "auto",
          overflowX: "hidden",
          backgroundColor: "#fff",
          width: "100%",
          border: `solid 1px ${validationState === "error" ? red : darkSkyBlue}`,
          display: "flex",
          flexDirection: "column",
          zIndex: 1030,
          marginTop: -3,
          borderBottomRightRadius: 4,
          borderBottomLeftRadius: 4,
          overflow: "hidden",
          height: "auto",
          boxSizing: "border-box",
          ...css,
        }}
        {...props}
      >
        {children}
      </div>
    </div>
  );
}

Menu.propTypes = {
  children: PropTypes.any.isRequired,
  style: PropTypes.object,
  validationState: PropTypes.oneOf(["error"]),
  css: PropTypes.object,
};

Menu.defaultProps = {
  style: null,
  validationState: null,
  css: {},
};
